import { NgModule } from 'angular-ts-decorators';

import { moduleName } from '../constants';

import { HeroCustomizerV3GiftWrappingComponent } from './hero-customizer-v3-gift-wrapping.component';

@NgModule({
  declarations: [
    HeroCustomizerV3GiftWrappingComponent,
  ],
  id: `${moduleName}.gift-wrapping`,
  providers: [],
})
export class HeroCustomizerV3GiftWrappingModule {
}
